import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <div className="address-section-one">
        <div className="container">
          <div className="inner-content bg-black">
            <div className="row g-0">
              <div className="col-md-6 ">
                <div className="address-block-one text-center my-auto mx-auto">
                  <div className="text-meta">
                    <h4 className="title fs-2 text-white">
                      Join Our Community
                    </h4>
                  </div>{" "}
                  {/* /.text-meta */}
                </div>{" "}
                {/* /.address-block-one */}
              </div>
              <div className="col-md-6 ">
                <div className="address-block-one text-center">
                  <div className="text-meta sm-pt-0">
                    <div className="social-icon style-none">
                      <a

                        href="https://x.com/XGlobal0311?t=LFjwi8XVqi6W90rZn2iHHg&s=09"
                      >
                        <i className="fab fa-twitter display-6  mr-3" />
                      </a>
                      <a

                        href="https://www.instagram.com/xglobal0311?igsh=b25iMmp0bjVhMGRt"
                      >
                        &nbsp;&nbsp;&nbsp;
                        <i className="fab fa-instagram display-6 mr-3" />
                      </a>
                      <a

                        href="https://youtube.com/@xglobal-o2x?si=h4QCxpYHbO_KuF0Y"
                      >
                        &nbsp;&nbsp;&nbsp;
                        <i className="fab fa-youtube display-6 mr-3" />
                      </a>
                      <a

                        href="https://www.facebook.com/share/1EyTsKBN5i/"
                      >
                        &nbsp;&nbsp;&nbsp;
                        <i className="fab fa-facebook display-6 mr-3" />
                      </a>
                      <a href="https://t.me/+Hq5quqnQ5t41Nzg1">
                        &nbsp;&nbsp;&nbsp;
                        <i className="fab fa-telegram-plane display-6 mr-3" />
                      </a>
                    </div>
                  </div>{" "}
                  {/* /.text-meta */}
                </div>{" "}
                {/* /.address-block-one */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-style-three theme-basic-footer mt-70">
        <img
          src="images/shape/shape_30.png"
          alt=""
          className="shapes shape-one"
        />
        <img
          src="images/shape/shape_28.png"
          alt=""
          className="shapes shape-two"
        />
        <img
          src="images/shape/shape_29.png"
          alt=""
          className="shapes shape-three"
        />
        <div className="container">
          <div className="inner-wrapper">
            {/* <div className="row mt-60 justify-content-center">
              <div className="col-lg-2 footer-intro mb-40">
                <div className="newsletter">
                  <h5 className="footer-title text-left">Ecosystem </h5>

                  <ul className="footer-nav-link style-none">
                    <li>
                      <a>XGlobal Studio</a>
                    </li>
                    <li>
                      <a>Governance</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-sm-6 mb-30">
                <h5 className="footer-title">Technology</h5>
                <ul className="footer-nav-link style-none">
                  <li>
                    <Link to="3">
                      Wallet
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      Testnet
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      Mainnet
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      Network
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-xl-2 col-md-3 col-sm-6 mb-30">
                <h5 className="footer-title">Community</h5>
                <ul className="footer-nav-link style-none">
                  <li>
                    <Link to="#">
                      Blog
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      Community
                    </Link>
                  </li>

                  <li>
                    <Link to="#">
                      Brand Kit
                    </Link>
                  </li>
                  <li>
                    <Link>Support</Link>
                  </li>
                </ul>
              </div>
              <div className="col-xl-2 col-md-3 col-sm-6 mb-30">
                <h5 className="footer-title">Developer </h5>
                <ul className="footer-nav-link style-none">
                  <li>
                    <a href="#">
                      Documentation
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      Developer Guide
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      Dev Forum
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      {" "}
                      Token issue
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-xl-2 col-md-3 col-sm-6 mb-30">
                <h5 className="footer-title">Learn</h5>
                <ul className="footer-nav-link style-none">
                  <li>
                    <a

                      href="/about"
                    >
                      About us{" "}
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      XGlobal Coin
                    </a>
                  </li>
                  <li>
                    <a href="/research">
                      Research{" "}
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      Careers
                    </a>
                  </li>
                  <li>
                    <Link to="/ecosystem">
                      Ecosystem
                    </Link>
                  </li>
                </ul>
              </div>
            </div> */}

            {/* <div className="row">
              <div className="col-xl-12 mb-30">
                <div className="newsletter ps-xl-5">
                  <h5 className="footer-title">Subscribe - Email </h5>
                  <p> Keep up to date with our progress</p>
                  <form className="footer_subscribe">
                    <input type="email" placeholder="Enter your email" />
                    <button disabled>Subscribe</button>
                  </form>
                  <div className="info">
                    We only send interesting and relevant emails.
                  </div>
                </div>
              </div>
            </div> */}

            <div className="bottom-footer">
              <div className="d-lg-flex justify-content-between align-items-center">
                <ul className="order-lg-1 pb-15 d-flex justify-content-center footer-nav style-none">
                  <li>
                    <a

                      href="#"
                    >
                      XGlobal Terms of use
                    </a>
                  </li>
                  <li>
                    <a

                      href="#"
                    >
                      Privacy policy
                    </a>
                  </li>
                </ul>
                <p className="copyright text-center order-lg-0 pb-15">
                  Copyright @2022 XGlobal Solution{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Footer;
